import { render, staticRenderFns } from "./openNewLiveSigin.vue?vue&type=template&id=0c7b3524&scoped=true&"
import script from "./openNewLiveSigin.vue?vue&type=script&lang=js&"
export * from "./openNewLiveSigin.vue?vue&type=script&lang=js&"
import style0 from "./openNewLiveSigin.vue?vue&type=style&index=0&id=0c7b3524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b3524",
  null
  
)

export default component.exports